import React from "react";
import { Box, Chip } from "@mui/material";

const MenuTabs = ({ brands, activeTab, onTabChange }) => {
  return (
    <Box
      sx={{
        display: "flex",
        gap: "8px",
        marginBottom: "16px",
        backgroundColor: "#f2f2f2",
        padding: "14px 11px",
        borderRadius: "5px",
        flexWrap: "wrap",
      }}
    >
      {brands.map((brand) => (
        <Chip
          key={brand.id}
          label={brand.label}
          onClick={() => onTabChange(brand.id)}
          sx={{
            backgroundColor: activeTab === brand.id ? "#e5007e" : "#fcfcfc",
            color: activeTab === brand.id ? "#fcfcfc" : "#000",
            fontWeight: 900,
            borderRadius: "81.3px",
            padding: "2px 10px 4px",
            cursor: "pointer",
            "&:hover": {
              bgcolor: "#e5007e",
              color: "#f0f0f0f0",
            },
          }}
        />
      ))}
    </Box>
  );
};

export default MenuTabs;
